import React from "react";

import { Box, Typography } from "@mui/material";
import data from "@src/data/data.json";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";
import { AggregatorSelect } from "@src/pages/Analytics/components/AggregatorSelect";

interface SalesHeaderProps {
  onPeriodSelected: (start: Date, end: Date) => void;

  onAggregatorSelect: (aggregator: string) => void;
}

export const SalesHeader: React.FC<SalesHeaderProps> = (props) => {
  const { onPeriodSelected } = props;

  const language = useSelector(selectCurrentLanguage);

  const headerData = data[language].Analytics.Sales.Header;
  const onAggregatorSelected = (aggregators: string[]) => {
    setSelectedAggregators(aggregators);
    props.onAggregatorSelect(aggregators[0]);
  };

  const [selectedAggregators, setSelectedAggregators] = React.useState([
    "wolt",
  ]);

  return (
    <>
      <Box
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        marginBottom={"50px"}
        justifyContent={"space-between"}
      >
        <AggregatorSelect
          availableAggregators={["wolt", "glovo", "yandex", "all"]}
          title={headerData.Title}
          selectedAggregators={selectedAggregators}
          onAggregatorSelected={onAggregatorSelected}
          onPeriodSelected={onPeriodSelected}
          isMultiSelect={false}
        />
      </Box>
    </>
  );
};
